import React from 'react';
import { Field, CccisdInput, CccisdToggle } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    show: true,
    overallFidelity: {
        show: true,
        title: 'Overall Fidelity',
        description: 'Across selected group(s)',
        targetScore: 4,
    },
    benchmark: {
        show: true,
        title: 'Benchmark',
        description: 'Sessions met benchmark across selected group(s)',
    },
    bySession: {
        show: true,
        title: 'By Session',
        description: 'Across selected group(s)',
    },
};

const Component = props => {
    return (
        <div>
            <Field name="show" component={CccisdToggle} label="Show Summary Callouts?" />
            <h4>Callout 1</h4>
            <Field name="overallFidelity.show" component={CccisdToggle} label="Show Callout 1?" />
            <Field name="overallFidelity.title" component={CccisdInput} label="Title" />
            <Field name="overallFidelity.description" component={CccisdInput} label="Description" />
            <Field
                name="overallFidelity.targetScore"
                component={CccisdInput}
                label="Target Fidelity Score"
                type="number"
            />
            <h4>Callout 2</h4>
            <Field name="benchmark.show" component={CccisdToggle} label="Show Callout 2?" />
            <Field name="benchmark.title" component={CccisdInput} label="Title" />
            <Field name="benchmark.description" component={CccisdInput} label="Description" />
            <h4>Callout 3</h4>
            <Field name="bySession.show" component={CccisdToggle} label="Show Callout 3?" />
            <Field name="bySession.title" component={CccisdInput} label="Title" />
            <Field name="bySession.description" component={CccisdInput} label="Description" />
        </div>
    );
};

export default widgetBuilder({ initialValues })(Component);
